// ------------------------------------------------------------
// Helpers
// ------------------------------------------------------------
const now = () => new Date();
const iso = () => new Date().toISOString();

const MockTournamentData = {
  // ------------------------------------------------------------
  // FRONTEND CONFIG / META
  // ------------------------------------------------------------
  currentSeason: {
    maxFinalistWeeks: 8,
    year: 2026,
    lastConfirmedWeekCount: 8,
  },

  // Your period dropdown can still be driven by localStorage.
  // Keeping this here just in case you want mock snapshot to include it.
  period: "startsToday", // startsToday | startsTomorrow | closedToday | closedTomorrow

  // ⭐ Single source of truth for "backend current round"
  // Set this to whichever round you want active in the UI.
  currentTournamentRoundId: "round-uuid-championship-purgeCompleted",

  // Quick switches (no logic required)
  scenarios: {
    // Enables Begin Tournament Year button:
    beginTournamentYearEnabled: "round-uuid-championship-purgeCompleted",

    // Enables Open Finalist Contestants (if period === startsToday):
    finalistOpenWeek1: "round-uuid-finalist-week-1-open",

    // Enables Purge Contestants (Prep Next Finalist Round):
    finalistClosedWeek1: "round-uuid-finalist-week-1-closed",

    // Tie break testing:
    championshipTieBreakWeek8: "round-uuid-championship-week-8-tieBreak",
  },

  // ------------------------------------------------------------
  // USERS (minimal shape for UI)
  // ------------------------------------------------------------
  users: [
    {
      id: "user-uuid-1",
      username: "stanMarsh",
      isNotifiable: true,
      createdAt: iso(),
      updatedAt: iso(),
    },
    {
      id: "user-uuid-2",
      username: "kyleBroflovski",
      isNotifiable: true,
      createdAt: iso(),
      updatedAt: iso(),
    },
    {
      id: "user-uuid-3",
      username: "ericCartman",
      isNotifiable: true,
      createdAt: iso(),
      updatedAt: iso(),
    },
  ],

  // ------------------------------------------------------------
  // SKITS (aligned with your updated enum intention)
  // skitStatus: performing | needsReview | suspended
  // ------------------------------------------------------------
  skits: [
    {
      id: "skit-uuid-1",
      sourceId: "user-uuid-1",
      categoryid: 100,
      skitThumbNailPosterImgUrl: "/mock/thumbs/skit-1.jpg",
      mediaUrl: "/mock/media/skit-1.mp4",
      title: "When your ex calls you and you already moved on",
      views: 3700,
      claps: 210,
      totalRatingSum: 18.0,
      ratingCount: 4,
      weightedAverageRating: 4.5,
      notInterestedCount: 2,
      storyLineAverageScore: 4.2,
      originalityAverageScore: 4.7,
      performanceAverageScore: 4.4,
      categoryAverageScore: 4.5,
      duration: 32.5,
      frameRate: 29.97,
      resolution: "1920x1080",
      fileSize: 24839201,
      skitStatus: "performing",
      whistleBlownCount: 0,
      reportReasons: null,
      createdAt: now(),
      updatedAt: now(),
    },
    {
      id: "skit-uuid-2",
      sourceId: "user-uuid-2",
      categoryid: 200,
      skitThumbNailPosterImgUrl: "/mock/thumbs/skit-2.jpg",
      mediaUrl: "/mock/media/skit-2.mp4",
      title: "Flying High",
      views: 4400,
      claps: 510,
      totalRatingSum: 24.0,
      ratingCount: 5,
      weightedAverageRating: 4.8,
      notInterestedCount: 1,
      storyLineAverageScore: 4.6,
      originalityAverageScore: 4.8,
      performanceAverageScore: 4.9,
      categoryAverageScore: 4.7,
      duration: 41.1,
      frameRate: 30.0,
      resolution: "1280x720",
      fileSize: 18200322,
      skitStatus: "performing",
      whistleBlownCount: 0,
      reportReasons: null,
      createdAt: now(),
      updatedAt: now(),
    },
    {
      id: "skit-uuid-3",
      sourceId: "user-uuid-3",
      categoryid: 300,
      skitThumbNailPosterImgUrl: "/mock/thumbs/skit-3.jpg",
      mediaUrl: "/mock/media/skit-3.mp4",
      title: "Shaq on Trump",
      views: 3100000,
      claps: 90000,
      totalRatingSum: 49.0,
      ratingCount: 10,
      weightedAverageRating: 4.9,
      notInterestedCount: 120,
      storyLineAverageScore: 4.9,
      originalityAverageScore: 4.9,
      performanceAverageScore: 5.0,
      categoryAverageScore: 4.8,
      duration: 58.3,
      frameRate: 30.0,
      resolution: "1920x1080",
      fileSize: 55400321,
      skitStatus: "performing",
      whistleBlownCount: 2,
      reportReasons: { spam: 1, harassment: 1 },
      createdAt: now(),
      updatedAt: now(),
    },
  ],

  // ------------------------------------------------------------
  // TOURNAMENT ROUNDS
  // status enum supports your milestone flow:
  // open | deciding | tieBreak | closed | ended | purging | purgeCompleted | competing | beginYear
  //
  // stage enum (recommended):
  // kickoffSeason | finalist | championship
  // ------------------------------------------------------------
  tournamentRounds: [
    // ✅ Result of: "Check if championship is complete" (on success)
    // Enables: "Begin tournament year"
    {
      id: "tournament-round-uuid-1",
      stage: "kickoffSeason", // this will change it is patched
      status: "closed", // this will change it is patched
      tournamentRoundCount: 0, // this will change to 1 it is patched
      championShipCountDown: 12, // i will set the max value at the begining and decrement this on each new record
      entryPeriod: null, // this will change to "starts today"
      createdAt: iso(),
      updatedAt: iso(),
    },

    // ✅ Result of: "Begin tournament year"
    // (Your flow: begin year sets finalist week 1 to CLOSED first, then Open Finalist Contestants flips CLOSED -> OPEN)
  ],

  // ------------------------------------------------------------
  // ROUND ENTRIES
  // competitionStatus: contestant | tied | finalist | champion
  // ------------------------------------------------------------
  roundEntries: [
    // Finalist week 1 contestants
    {
      id: "roundEntry-uuid-1",
      roundId: "tournament-round-uuid-3", // FK -> tournamentRounds.id (points to finalist week 1 OPEN)
      skitId: "skit-uuid-1",
      competitionStatus: "contestant",
      createdAt: iso(),
      updatedAt: iso(),
    },
    {
      id: "roundEntry-uuid-2",
      roundId: "tournament-round-uuid-3",
      skitId: "skit-uuid-2",
      competitionStatus: "tied",
      createdAt: iso(),
      updatedAt: iso(),
    },
    {
      id: "roundEntry-uuid-3",
      roundId: "tournament-round-uuid-3",
      skitId: "skit-uuid-3",
      competitionStatus: "tied",
      createdAt: iso(),
      updatedAt: iso(),
    },
  ],
  // ------------------------------------------------------------
  // ACTIVITY LOGS (minimal examples)
  // ------------------------------------------------------------
  activityLogs: [
    {
      id: "activity-log-uuid-1",
      sourceId: "user-uuid-1",
      relatedId: "skit-uuid-2",
      activityId: null,
      targetId: "user-uuid-2",
      activity: "viewed",
      value: 1,
      notificationMessage: null,
      emojiChoiceName: null,
      is_targetId_notifiable: true,
      memberReferred: false,
      is_sourceId_notifiable: false,
      didUploadSkit: false,
      readByTargetAt: null,
      readBySourceAt: null,
      if_targetId_notified: null,
      if_sourceId_notified: null,
      skitUrlLink: "/skit/skit-uuid-2",
      createdAt: now(),
      updatedAt: now(),
    },
  ],
};

export default MockTournamentData;
